import type { MeResponse } from "../../api/types";
import { hasPermission } from "../../auth/permissions";
import { ForbiddenPage } from "../ForbiddenPage";
import { Adjustments } from "./Adjustments";
import { CoinUploads } from "./CoinUploads";
import { Ledger } from "./Ledger";
import { People } from "./People";
import { Seasons } from "./Seasons";
import { Themes } from "./Themes";

export function AdminPage({ me, path }: { me: MeResponse; path: string }) {
  if (path === "/admin/ledger") {
    if (!hasPermission(me, "gumballs:ledger:view")) {
      return <ForbiddenPage me={me} />;
    }
    return <Ledger />;
  }
  if (path === "/admin/coin-uploads") {
    if (!hasPermission(me, "gumballs:coins:upload")) {
      return <ForbiddenPage me={me} />;
    }
    return <CoinUploads />;
  }
  if (path === "/admin/adjustments") {
    if (!hasPermission(me, "gumballs:balances:adjust")) {
      return <ForbiddenPage me={me} />;
    }
    return <Adjustments />;
  }
  if (path === "/admin/seasons") {
    if (!hasPermission(me, "gumballs:season:manage")) {
      return <ForbiddenPage me={me} />;
    }
    return <Seasons />;
  }
  if (path === "/admin/themes") {
    if (!hasPermission(me, "settings:manage")) {
      return <ForbiddenPage me={me} />;
    }
    return <Themes />;
  }
  if (!hasPermission(me, "members:view")) {
    return <ForbiddenPage me={me} />;
  }
  return <People />;
}
